import React from 'react';

import {User} from 'src/openapi/models/User';

import {AvatarWrapped} from '@pb/kit-component-avatar';
import {Icons} from '@pb/kit-component-icon';

type Props = {
    user: User,
};

export const Avatar = ({user}: Props) => {
    const firstName = user?.firstName || '';
    const lastName = user?.lastName || '';
    const avatar = user?.avatar || '';

    return (
        <AvatarWrapped
            size="SMALL"
            alt={`${firstName} ${lastName}`}
            name={{firstName, lastName}}
            src={avatar}
            placeholder={Icons.PERSON_ROUNDED}
        />
    );
};
